import React from 'react';
import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';
import FieldOrNoData from '~/features/base/components/FieldOrNoData';
import { copyToClipboard } from '~/features/apps/utils/appsUtils';

const truncateValue = (value) => {
    if (!value || value.length <= 40) return value;
    return value.substring(0, 10) + "...." + value.substring(value.length - 10, value.length);
};

const CopyButton = ({ value }) => (
    <OverlayTrigger placement='top' overlay={
        <Tooltip id='tooltip' className='top-right'>
            <FormattedMessage id='intl-msg:copyIvd'/>
        </Tooltip>}>
        <span onClick={() => copyToClipboard(value, true)}
              className='uikit-icon icon-duplicate text-color-dark text-size-20 padding-left-5'>
        </span>
    </OverlayTrigger>
);

const MismatchWarning = () => (
    <OverlayTrigger placement='top' overlay={
        <Tooltip id='tooltip' className='top-right'>
            <FormattedMessage id='intl-msg:ivd.mismatchTooltip'/>
        </Tooltip>}>
        <div className='text-warning text-size-12'>
            <span className='uikit-icon icon-error-sign margin-right-5 text-size-16'></span>
            <FormattedMessage id='intl-msg:ivdMismatchWarning'/>
        </div>
    </OverlayTrigger>
);

const IvdMatchNotification = () => (
    <OverlayTrigger placement='top' overlay={
        <Tooltip id='tooltip' className='top-right'>
            <FormattedMessage id='intl-msg:ivdMatch'/>
        </Tooltip>}>
        <span className='uikit-icon icon-ok-sign margin-right-5 text-size-16 text-color-success margin-left-5'></span>
    </OverlayTrigger>
);

const IvdRows = ({ rows }) => {
    const elements = [];
    rows.forEach(({ labelId, displayValue, originalValue }, index) => {
        elements.push(
            <label key={`label-${index}`}><FormattedMessage id={labelId} />:</label>,
            <div key={`value-${index}`}>
                <FieldOrNoData field={displayValue?.toLowerCase()}/>
                {originalValue && <CopyButton value={originalValue?.toLowerCase()} />}
            </div>
        );
    });
    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '0 10px', alignItems: 'center' }}>
            {elements}
        </div>
    );
};

const IvdField = ({ field, item }) => {
    const {ivdMismatch, expectedIvd} = item;
    const displayValue = truncateValue(field);

    if (ivdMismatch === false) {
        return (
            <div className={'word-break'}>
                <FieldOrNoData field={displayValue}/>
                {field && <CopyButton value={field} />}
                <IvdMatchNotification/>
            </div>
        );
    }

    const displayValueExpected = truncateValue(expectedIvd);

    return (
        <div>
            {ivdMismatch && <MismatchWarning/>}
            {!ivdMismatch && <div className='text-info text-size-12 margin-bottom-5'>
                <span className='uikit-icon icon-info-sign margin-right-5 text-size-16'></span>
                <FormattedMessage id='intl-msg:ivdNotReportedByNasys'/>
            </div>}
            <IvdRows rows={[
                {
                    labelId: 'intl-msg:reportedByDevice',
                    displayValue: displayValue,
                    originalValue: field
                },
                {
                    labelId: 'intl-msg:reportedByNasys',
                    displayValue: displayValueExpected,
                    originalValue: expectedIvd
                }
            ]} />
        </div>
    );
};

export default IvdField;
